import { Injectable, Component } from '@angular/core';
import { NgbModal } from 'modal/modal';
import { LoginModalComponent } from './login-modal.component';
import { AppConstants } from 'app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class LoginModalService {


  constructor(public modalService: NgbModal) { }
  openLoginModal(component: Component, options?: {
    activeAction: any,
    mobileNumber?: string,
    email?: string
  }) {
    const opts = Object.assign({}, AppConstants.largeModaloptionsForShivam);
    opts.container = 'app-root';

    const modalRef = this.modalService.open(component, opts);
    if (options) {
      const lmcInstance: LoginModalComponent = modalRef.componentInstance;
      lmcInstance.activeAction = options.activeAction;
      lmcInstance.mobileNumber = options.mobileNumber || '';
      lmcInstance.email = options.email || '';
    }

    return modalRef;
  }

}
